var _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBox2(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.75 5.7834C16.75 6.2334 16.5083 6.64171 16.125 6.85004L14.675 7.63338L13.4417 8.29174L10.8833 9.67505C10.6083 9.82505 10.3083 9.90007 10 9.90007C9.69167 9.90007 9.39167 9.82505 9.11667 9.67505L3.875 6.85004C3.49167 6.64171 3.25 6.2334 3.25 5.7834C3.25 5.3334 3.49167 4.92504 3.875 4.71671L5.51667 3.83338L6.82501 3.12507L9.11667 1.89175C9.66667 1.59175 10.3333 1.59175 10.8833 1.89175L16.125 4.71671C16.5083 4.92504 16.75 5.3334 16.75 5.7834Z",
    fill: "#CCCFD6"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M8.24993 10.6582L3.37492 8.21657C2.99992 8.02491 2.5666 8.0499 2.20826 8.26657C1.84993 8.48324 1.6416 8.8666 1.6416 9.28326V13.8916C1.6416 14.6916 2.08325 15.4082 2.79992 15.7666L7.67493 18.1999C7.84159 18.2833 8.02494 18.3249 8.20827 18.3249C8.42494 18.3249 8.64161 18.2666 8.83327 18.1416C9.19161 17.9249 9.39993 17.5416 9.39993 17.1249V12.5166C9.40827 11.7333 8.9666 11.0166 8.24993 10.6582Z",
    fill: "#9CA3AE"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M18.3585 9.29172V13.9C18.3585 14.6917 17.9168 15.4083 17.2001 15.7667L12.3251 18.2083C12.1585 18.2917 11.9751 18.3334 11.7918 18.3334C11.5751 18.3334 11.3585 18.2751 11.1585 18.1501C10.8085 17.9334 10.5918 17.55 10.5918 17.1334V12.5333C10.5918 11.7333 11.0335 11.0167 11.7501 10.6583L13.5418 9.76667L14.7918 9.14167L16.6251 8.22502C17.0001 8.03336 17.4335 8.05002 17.7918 8.27502C18.1418 8.49169 18.3585 8.87505 18.3585 9.29172Z",
    fill: "#CCCFD6"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBox2);
export default __webpack_public_path__ + "static/media/box-2.29bdb73ec04677b7bdbaf01973d8b341.svg";
export { ForwardRef as ReactComponent };